import Large from './Large';
import Regular from './Regular';
import Small from './Small';
import Action from './Action';

export default {
  Large,
  Regular,
  Small,
  Action,
};

export const Text = Regular;
export const TextLarge = Large;
export const TextRegular = Regular;
export const TextSmall = Small;
